import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn, openLogin, openSignup } from '../auth.js';
import './ProtectedApp.css';

interface ProtectedAppProps {
  children: React.ReactNode;
}

const ProtectedApp: React.FC<ProtectedAppProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = () => {
      const loggedIn = isLoggedIn();
      setIsAuthenticated(loggedIn);
      
      // If user is not logged in, redirect to landing page
      if (!loggedIn) {
        navigate('/');
        return;
      }
      
      setIsLoading(false);
    };

    checkAuthStatus();
    
    // Listen for auth changes
    const interval = setInterval(checkAuthStatus, 1000);
    return () => clearInterval(interval);
  }, [navigate]);

  // Show loading state
  if (isLoading) {
    return (
      <div className="protected-app-loading">
        <div className="loading-spinner"></div>
        <p>Checking access...</p>
      </div>
    );
  }

  // Show authentication gate
  if (!isAuthenticated) {
    // Redirect immediately instead of showing gate
    navigate('/');
    return null;
  }

  // User is authenticated - show the app (no subscription required)
  return <>{children}</>;
};

export default ProtectedApp;
